module.exports = __webpack_public_path__ + "static/img/kf_qrcode.17398ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kf_qrcode.png
// module id = 5Gcv
// module chunks = 1